/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_About_TitleInputs */

const en_meta_about_title = /** @type {(inputs: Meta_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Lindevo — AI automation company in Liepāja, Latvia`)
};

const lv_meta_about_title = /** @type {(inputs: Meta_About_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par Lindevo — AI automatizācijas uzņēmums Liepājā`)
};

/**
* | output |
* | --- |
* | "About Lindevo — AI automation company in Liepāja, Latvia" |
*
* @param {Meta_About_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_about_title = /** @type {((inputs?: Meta_About_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_About_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_about_title(inputs)
	return en_meta_about_title(inputs)
});